import React, { ReactNode } from "react";
import { Flex, Header } from "@fluentui/react-northstar";
import styles from "./reportElementWrapper.module.scss";
import classNames from "classnames";

interface ReportElementWrapperProps {
    report: any;
    additionalClassName?: string;
    renderReportElement: (report: any) => ReactNode;
    reportElementTitle: (report: any) => string | undefined;
    reportElementText: (report: any) => string | undefined;
}

const ReportElementWrapper: React.FC<ReportElementWrapperProps> = (props: ReportElementWrapperProps) => {
    return (
        <div className={classNames(styles.wrapper, props.additionalClassName)}>
            <Flex column padding="padding.medium">
                <Header as="h5" content={props.reportElementText(props.report)} className={styles.header} />
                {props.renderReportElement(props.report)}
            </Flex>
        </div>
    );
};

export default ReportElementWrapper;
